import { useDispatch } from "react-redux";
import { Link, useMatch, useNavigate } from "react-router-dom";
import { filterByType } from "../../features/filter/filterSlice";

const Filter = () => {
    const dispatch = useDispatch();

    const match = useMatch("/");
    const navigate = useNavigate();

    const handleClick = (e, type) => {
        e.preventDefault();
        dispatch(filterByType(type));
        if (!match) {
            navigate("/");
        }
    };

    return (
        <li>
            <Link
                to="/"
                className="main-menu menu-active"
                id="lws-alljobs-menu"
                onClick={(e) => handleClick(e, "")}
            >
                <i className="fa-solid fa-briefcase"></i>
                <span> All Available Jobs</span>
            </Link>
            <ul className="space-y-6 lg:space-y-2 ">
                <li>
                    <Link
                        className="sub-menu"
                        to="/jobs/internship"
                        id="lws-internship-menu"
                        onClick={(e) => handleClick(e, "Internship")}
                    >
                        <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                        Internship
                    </Link>
                </li>
                <li>
                    <Link
                        className="sub-menu"
                        to="/jobs/fulltime"
                        id="lws-fulltime-menu"
                        onClick={(e) => handleClick(e, "Full Time")}
                    >
                        <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                        Full Time
                    </Link>
                </li>
                <li>
                    <Link
                        className="sub-menu"
                        to="/jobs/remote"
                        id="lws-remote-menu"
                        onClick={(e) => handleClick(e, "Remote")}
                    >
                        <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                        Remote
                    </Link>
                </li>
            </ul>
        </li>
    );
};

export default Filter;
